import Login from "pages/home/login";

import Main from "components/common/Main";

// PORTAL ROUTES

import AddBiologicalInformation from "pages/portals/biologicalInformation/AddBiologicalInformation";
import ViewBiologicalInformation from "pages/portals/biologicalInformation/ViewBiologicalInformation";
import EditBiologicalInformation from "pages/portals/biologicalInformation/EditBiologicalInformation";
import ViewAllBiologicalInformation from "pages/portals/biologicalInformation/ViewAllBiologicalInformation";

import AddCouncil from "pages/portals/council/AddCouncil";
import ViewCouncil from "pages/portals/council/ViewCouncil";
import EditCouncil from "pages/portals/council/EditCouncil";

import AddDebate from "pages/portals/debate/AddDebate";

import AddFaq from "pages/portals/faqs/AddFaq";
import ViewFaq from "pages/portals/faqs/ViewFaq";
import EditFaq from "pages/portals/faqs/EditFaq";
import ViewAllFaq from "pages/portals/faqs/ViewAllFaq";

import AddGallery from "pages/portals/gallery/AddGallery";
import ViewGallery from "pages/portals/gallery/ViewGallery";
import EditGallery from "pages/portals/gallery/EditGallery";
import ViewAllGallery from "pages/portals/gallery/ViewAllGallery";
import ViewGalleryImage from "pages/portals/gallery/ViewGalleryImage";

import AddHouse from "pages/portals/house/AddHouse";
import ViewHouse from "pages/portals/house/ViewHouse";
import EditHouse from "pages/portals/house/EditHouse";

import EditInterest from "pages/portals/interestRequest/EditInterest";
import EditRequest from "pages/portals/interestRequest/EditRequest";
import ViewInterest from "pages/portals/interestRequest/ViewInterest";
import ViewRequest from "pages/portals/interestRequest/ViewRequest";
import ViewInterestRequest from "pages/portals/interestRequest/ViewInterestRequest";

import AddLegislativeAssembly from "pages/portals/legislativeAssembly/AddLegilativeAssembly";
import EditLegislativeAssembly from "pages/portals/legislativeAssembly/EditLegilativeAssembly";
import ViewLegislativeAssembly from "pages/portals/legislativeAssembly/ViewLegilativeAssembly";
import ViewAllLegislativeAssembly from "pages/portals/legislativeAssembly/ViewAllLegilativeAssembly";

import AddLegislativeCouncil from "pages/portals/legislativeCouncil/AddLegilativeCouncil";
import EditLegislativeCouncil from "pages/portals/legislativeCouncil/EditLegilativeCouncil";
import ViewLegislativeCouncil from "pages/portals/legislativeCouncil/ViewLegilativeCouncil";
import ViewAllLegislativeCouncil from "pages/portals/legislativeCouncil/ViewAllLegilativeCouncil";

import AddLegislativeMember from "pages/portals/legislativeMember/AddLegilativeMember";
import ViewLegislativeMember from "pages/portals/legislativeMember/ViewLegilativeMember";
import EditLegislativeMember from "pages/portals/legislativeMember/EditLegilativeMember";
import ViewMemberProfile from "pages/portals/legislativeMember/ViewMemberProfile";
import ViewAllLegislativeMember from "pages/portals/legislativeMember/ViewAllLegilativeMember";

import AddLibrary from "pages/portals/library/AddLibrary";
import EditLibrary from "pages/portals/library/EditLibrary";
import ViewLibrary from "pages/portals/library/ViewLibrary";
import ViewAllLibrary from "pages/portals/library/ViewAllLibrary";

import AddLibraryDoc from "pages/portals/libraryDoc/AddLibraryDoc";
import EditLibraryDoc from "pages/portals/libraryDoc/EditLibraryDoc";
import ViewAllLibraryDoc from "pages/portals/libraryDoc/ViewAllLibraryDoc";

import AddMantriMandal from "pages/portals/mantriMandal/AddMantriMandal";
import ViewAllMantriMandal from "pages/portals/mantriMandal/ViewAllMantriMandal";
import ViewMantriMandal from "pages/portals/mantriMandal/ViewMantriMandal";
import EditMantriMandal from "pages/portals/mantriMandal/EditMantriMandal";

import AddRajyapal from "pages/portals/rajyapal/AddRajyapal";
import ViewRajyapal from "pages/portals/rajyapal/ViewRajyapal";
import EditRajyapal from "pages/portals/rajyapal/EditRajyapal";
import ViewAllRajyapal from "pages/portals/rajyapal/ViewAllRajyapal";

import AddSessionCalendar from "pages/portals/sessionCalendar/AddSessionCalendar";
import EditSessionCalendar from "pages/portals/sessionCalendar/EditSessionCalendar";
import ViewSessionCalendar from "pages/portals/sessionCalendar/ViewSessionCalendar";
import ViewAllSessionCalendar from "pages/portals/sessionCalendar/ViewAllSessionCalendar";

import AddVidhanMandal from "pages/portals/vidhanMandal/AddVidhanMandal";
import EditVidhanMandal from "pages/portals/vidhanMandal/EditVidhanMandal";
import ViewVidhanMandal from "pages/portals/vidhanMandal/ViewVidhanMandal";
import ViewAllVidhanMandal from "pages/portals/vidhanMandal/ViewAllVidhanMandal";

// MASTER ROUTES

import AddAssembly from "pages/masters/assembly/AddAssembly";
import ViewAssembly from "pages/masters/assembly/ViewAssembly";
import EditAssembly from "pages/masters/assembly/EditAssembly";

import AddBranch from "pages/masters/branch/AddBranch";
import ViewBranch from "pages/masters/branch/ViewBranch";
import EditBranch from "pages/masters/branch/EditBranch";

import AddCommittee from "pages/masters/committee/AddCommittee";
import ViewCommittee from "pages/masters/committee/ViewCommittee";
import EditCommittee from "pages/masters/committee/EditCommittee";

import AddConstituency from "pages/masters/constituency/AddConstituency";
import ViewConstituency from "pages/masters/constituency/ViewConstituency";
import EditConstituency from "pages/masters/constituency/EditConstituency";

import AddConstituencyType from "pages/masters/constituencyType/AddConstituencyType";
import ViewConstituencyType from "pages/masters/constituencyType/ViewConstituencyType";
import EditConstituencyType from "pages/masters/constituencyType/EditConstituencyType";

import AddDepartment from "pages/masters/department/AddDepartment";
import EditDepartment from "pages/masters/department/EditDepartment";
import ViewDepartment from "pages/masters/department/ViewDepartment";

import AddDesignation from "pages/masters/designation/AddDesignation";
import ViewDesignation from "pages/masters/designation/ViewDesignation";
import EditDesignation from "pages/masters/designation/EditDesignation";

import AddDistrict from "pages/masters/district/AddDistrict";
import ViewDistrict from "pages/masters/district/ViewDistrict";
import EditDistrict from "pages/masters/district/EditDistrict";

import AddGender from "pages/masters/gender/AddGender";
import ViewGender from "pages/masters/gender/ViewGender";
import EditGender from "pages/masters/gender/EditGender";

import AddLegislativePosition from "pages/masters/legislativePosition/AddLegislativePosition";
import EditLegislativePosition from "pages/masters/legislativePosition/EditLegislativePosition";
import ViewLegislativePosition from "pages/masters/legislativePosition/ViewLegislativePosition";

import AddMemberName from "pages/masters/memberName/AddMemberName";
import EditMemberName from "pages/masters/memberName/EditMemberName";
import ViewMemberName from "pages/masters/memberName/ViewMemberName";

import AddMinistry from "pages/masters/ministry/AddMinistry";
import ViewMinistry from "pages/masters/ministry/ViewMinistry";
import EditMinistry from "pages/masters/ministry/EditMinistry";

import AddNavigation from "pages/masters/navigation/AddNavigation";
import EditNavigation from "pages/masters/navigation/EditNavigation";
import ViewNavigation from "pages/masters/navigation/ViewNavigation";

import AddPoliticalParty from "pages/masters/politicalParty/AddPoliticalParty";
import EditPoliticalParty from "pages/masters/politicalParty/EditPoliticalParty";
import ViewPoliticalParty from "pages/masters/politicalParty/ViewPoliticalParty";

import AddPresidingOfficer from "pages/masters/presidingOfficer/AddPresidingOfficer";
import EditPresidingOfficer from "pages/masters/presidingOfficer/EditPresidingOfficer";
import ViewPresidingOfficer from "pages/masters/presidingOfficer/ViewPresidingOfficer";

import AddSessionField from "pages/masters/sessionField/AddSessionField";
import ViewSessionField from "pages/masters/sessionField/ViewSessionField";
import EditSessionField from "pages/masters/sessionField/EditSessionField";

// HOME ROUTES

import ViewAudit from "pages/home/audit-trail/ViewAudit";
import ViewAllUserAudit from "pages/home/audit-trail/ViewAllUserAudit";
import ViewUserAudit from "pages/home/audit-trail/ViewUserAudit";

import AddContact from "pages/home/contactUs/AddContact";
import EditContact from "pages/home/contactUs/EditContact";
import ViewContact from "pages/home/contactUs/ViewContact";

import EditFeedback from "pages/home/feedbacks/EditFeedback";
import ViewFeedback from "pages/home/feedbacks/ViewFeedback";
import ViewAllFeedback from "pages/home/feedbacks/ViewAllFeedback";

import AddFileManager from "pages/home/fileManager/AddFileManager";
import ViewFileManager from "pages/home/fileManager/ViewFileManager";
import EditFileManager from "pages/home/fileManager/EditFileManager";

import ViewAllHelpdesk from "pages/home/helpdesk/ViewAllHelpdesk";
import EditHelpdesk from "pages/home/helpdesk/EditHelpdesk";
import ViewHelpdesk from "pages/home/helpdesk/ViewHelpdesk";

import AddPortalBranch from "pages/home/portalBranch/AddPortalBranch";
import EditPortalBranch from "pages/home/portalBranch/EditPortalBranch";
import ViewPortalBranch from "pages/home/portalBranch/ViewPortalBranch";

import AddPortalDepartment from "pages/home/portalDepartment/AddPortalDepartment";
import EditPortalDepartment from "pages/home/portalDepartment/EditPortalDepartment";
import ViewPortalDepartment from "pages/home/portalDepartment/ViewPortalDepartment";

import AddPortalUser from "pages/home/portalUser/AddPortalUser";
import EditPortalUser from "pages/home/portalUser/EditPortalUser";
import ViewPortalUser from "pages/home/portalUser/ViewPortalUser";
import BlockPortalUser from "pages/home/portalUser/BlockPortalUser";
import ResetPortalUser from "pages/home/portalUser/ResetPortalUser";
import UploadPortalUser from "pages/home/portalUser/UploadPortalUser";

import AddSeo from "pages/home/seo/AddSeo";
import EditSeo from "pages/home/seo/EditSeo";
import ViewSeo from "pages/home/seo/ViewSeo";

import AddTask from "pages/home/systemManagement/AddTask";
import EditTask from "pages/home/systemManagement/EditTask";
import ViewTask from "pages/home/systemManagement/ViewTask";
import UserRole from "pages/home/systemManagement/UserRole";
import EditRole from "pages/home/systemManagement/EditRole";

import AddWorkflow from "pages/home/workflow/AddWorkflow";
import EditWorkflow from "pages/home/workflow/EditWorkflow";
import ViewWorkflow from "pages/home/workflow/ViewWorkflow";
import ViewAllWorkflow from "pages/home/workflow/ViewAllWorkflow";
import ViewWorkflowHistory from "pages/home/workflow/ViewWorkflowHistory";
import ViewArchive from "pages/home/workflow/ViewArchive";

// pending
import ViewWorkflowBiologicalInformation from "pages/pendings/ViewWorkflowBiologicalInformation";
import ViewWorkflowContactUs from "pages/pendings/ViewWorkflowContactUs";
import ViewWorkflowFaq from "pages/pendings/ViewWorkflowFaq";
import ViewWorkflowGallery from "pages/pendings/ViewWorkflowGallery";
import ViewWorkflowGalleryImage from "pages/pendings/ViewWorkflowGalleryImage";
import ViewWorkflowInterestRequest from "pages/pendings/ViewWorkflowInterestRequest";
import ViewWorkflowLegislativeAssembly from "pages/pendings/ViewWorkflowLegislativeAssembly";
import ViewWorkflowLegislativeCouncil from "pages/pendings/ViewWorkflowLegislativeCouncil";
import ViewWorkflowLibrary from "pages/pendings/ViewWorkflowLibrary";
import ViewWorkflowMantriMandal from "pages/pendings/ViewWorkflowMantriMandal";
import ViewWorkflowMemberProfile from "pages/pendings/ViewWorkflowMemberProfile";
import ViewWorkflowRajyapal from "pages/pendings/ViewWorkflowRajyapal";
import ViewWorkflowSessionCalendar from "pages/pendings/ViewWorkflowSessionCalendar";
import ViewWorkflowVidhanMandal from "pages/pendings/ViewWorkflowVidhanMandal";

import { paths } from "./paths";

export const routes = [
  {
    name: "Dashboard",
    path: "/Dashboard",
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <Main />,
  },
  {
    name: "Login",
    path: "/",
    exact: true,
    // access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <Login />,
  },

  // portals
  {
    name: "Biological Information",
    path: paths.addBiologicalInformation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddBiologicalInformation />,
  },
  {
    name: "Biological Information",
    path: paths.viewBiologicalInformation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewBiologicalInformation />,
  },
  {
    name: "Biological Information",
    path: paths.editBiologicalInformation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditBiologicalInformation />,
  },
  {
    name: "Biological Information",
    path: paths.viewAllBiologicalInformation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllBiologicalInformation />,
  },
  {
    name: "AddCouncil",
    path: paths.addCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <AddCouncil />,
  },
  {
    name: "ViewCouncil",
    path: paths.viewCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewCouncil />,
  },
  {
    name: "EditCouncil",
    path: paths.editCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditCouncil />,
  },
  {
    name: "Debate",
    path: paths.addDebate,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddDebate />,
  },
  {
    name: "Faqs",
    path: paths.addFaq,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddFaq />,
  },
  {
    name: "Faqs",
    path: paths.viewFaq,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewFaq />,
  },
  {
    name: "Faqs",
    path: paths.editFaq,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditFaq />,
  },
  {
    name: "Faqs",
    path: paths.viewAllFaq,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllFaq />,
  },
  {
    name: "Gallery",
    path: paths.addGallery,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddGallery />,
  },
  {
    name: "Gallery",
    path: paths.viewAllGallery,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllGallery />,
  },
  {
    name: "Gallery",
    path: paths.viewGallery,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewGallery />,
  },
  {
    name: "Gallery",
    path: paths.editGallery,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditGallery />,
  },
  {
    name: "Gallery",
    path: paths.viewGalleryImage,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewGalleryImage />,
  },
  {
    name: "Houses",
    path: paths.addHouse,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddHouse />,
  },
  {
    name: "Houses",
    path: paths.viewHouse,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewHouse />,
  },
  {
    name: "Houses",
    path: paths.editHouse,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditHouse />,
  },

  {
    name: "InterestRequest",
    path: paths.editInterest,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditInterest />,
  },
  {
    name: "InterestRequest",
    path: paths.editRequest,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditRequest />,
  },
  {
    name: "InterestRequest",
    path: paths.viewInterest,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewInterest />,
  },
  {
    name: "InterestRequest",
    path: paths.viewRequest,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewRequest />,
  },
  {
    name: "InterestRequest",
    path: paths.viewInterestRequest,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewInterestRequest />,
  },
  {
    name: "VidhanSabha",
    path: paths.viewAllLegislativeAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllLegislativeAssembly />,
  },
  {
    name: "VidhanSabha",
    path: paths.addLegislativeAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLegislativeAssembly />,
  },
  {
    name: "VidhanSabha",
    path: paths.viewLegislativeAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewLegislativeAssembly />,
  },
  {
    name: "VidhanSabha",
    path: paths.editLegislativeAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLegislativeAssembly />,
  },
  {
    name: "VidhanParishad",
    path: paths.viewAllLegislativeCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllLegislativeCouncil />,
  },
  {
    name: "VidhanParishad",
    path: paths.addLegislativeCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLegislativeCouncil />,
  },
  {
    name: "VidhanParishad",
    path: paths.viewLegislativeCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewLegislativeCouncil />,
  },
  {
    name: "VidhanParishad",
    path: paths.editLegislativeCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLegislativeCouncil />,
  },
  {
    name: "Legislative Member",
    path: paths.viewAllLegislativeMember,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllLegislativeMember />,
  },
  {
    name: "Legislative Member",
    path: paths.ViewLegislativeMember,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewLegislativeMember />,
  },
  {
    name: "Legislative Member",
    path: paths.addLegislativeMember,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLegislativeMember />,
  },
  {
    name: "Legislative Member",
    path: paths.editLegislativeMember,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLegislativeMember />,
  },
  {
    name: "Legislative Member",
    path: paths.viewMemberProfile,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewMemberProfile />,
  },
  {
    name: "Library",
    path: paths.addLibrary,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLibrary />,
  },
  {
    name: "Library",
    path: paths.viewLibrary,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewLibrary />,
  },
  {
    name: "Library",
    path: paths.editLibrary,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLibrary />,
  },
  {
    name: "Library",
    path: paths.viewAllLibrary,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllLibrary />,
  },
  {
    name: "Library",
    path: paths.addLibraryDoc,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLibraryDoc />,
  },
  {
    name: "Library",
    path: paths.editLibraryDoc,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLibraryDoc />,
  },
  {
    name: "Library",
    path: paths.viewAllLibraryDoc,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllLibraryDoc />,
  },
  {
    name: "MantriMandal",
    path: paths.addMantriMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <AddMantriMandal />,
  },
  {
    name: "MantriMandal",
    path: paths.viewAllMantriMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllMantriMandal />,
  },
  {
    name: "MantriMandal",
    path: paths.viewMantriMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewMantriMandal />,
  },
  {
    name: "MantriMandal",
    path: paths.editMantriMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <EditMantriMandal />,
  },
  {
    name: "Rajyapal",
    path: paths.addRajyapal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddRajyapal />,
  },
  {
    name: "Rajyapal",
    path: paths.editRajyapal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditRajyapal />,
  },
  {
    name: "Rajyapal",
    path: paths.viewRajyapal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewRajyapal />,
  },
  {
    name: "Rajyapal",
    path: paths.viewAllRajyapal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllRajyapal />,
  },
  {
    name: "Session Calendar",
    path: paths.addSessionCalendar,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddSessionCalendar />,
  },
  {
    name: "Session Calendar",
    path: paths.editSessionCalendar,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditSessionCalendar />,
  },
  {
    name: "Session Calendar",
    path: paths.viewSessionCalendar,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewSessionCalendar />,
  },
  {
    name: "Session Calendar",
    path: paths.viewAllSessionCalendar,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllSessionCalendar />,
  },
  {
    name: "VidhanMandal",
    path: paths.viewAllVidhanMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllVidhanMandal />,
  },
  {
    name: "VidhanMandal",
    path: paths.addVidhanMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddVidhanMandal />,
  },
  {
    name: "VidhanMandal",
    path: paths.viewVidhanMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewVidhanMandal />,
  },
  {
    name: "VidhanMandal",
    path: paths.editVidhanMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditVidhanMandal />,
  },

  // masters

  {
    name: "Assembly",
    path: paths.addAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddAssembly />,
  },
  {
    name: "Assembly",
    path: paths.viewAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAssembly />,
  },
  {
    name: "Assembly",
    path: paths.editAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditAssembly />,
  },
  {
    name: "Branch",
    path: paths.addBranch,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddBranch />,
  },
  {
    name: "Constituency Types",
    path: paths.viewBranch,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewBranch />,
  },
  {
    name: "Constituency Types",
    path: paths.editBranch,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditBranch />,
  },
  {
    name: "Committee",
    path: paths.addCommittee,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddCommittee />,
  },
  {
    name: "Committee",
    path: paths.viewCommittee,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewCommittee />,
  },
  {
    name: "Committee",
    path: paths.editCommittee,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditCommittee />,
  },
  {
    name: "Constituency",
    path: paths.addConstituency,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddConstituency />,
  },
  {
    name: "Constituency",
    path: paths.viewConstituency,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewConstituency />,
  },
  {
    name: "Constituency",
    path: paths.editConstituency,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditConstituency />,
  },
  {
    name: "Constituency Types",
    path: paths.addConstituencyType,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddConstituencyType />,
  },
  {
    name: "Constituency Types",
    path: paths.viewConstituencyType,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewConstituencyType />,
  },
  {
    name: "Constituency Types",
    path: paths.editConstituencyType,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditConstituencyType />,
  },
  {
    name: "Department",
    path: paths.addDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <AddDepartment />,
  },
  {
    name: "Department",
    path: paths.viewDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewDepartment />,
  },
  {
    name: "Department",
    path: paths.editDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditDepartment />,
  },
  {
    name: "Designation",
    path: paths.addDesignation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddDesignation />,
  },
  {
    name: "Designation",
    path: paths.editDesignation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditDesignation />,
  },
  {
    name: "Designation",
    path: paths.viewDesignation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewDesignation />,
  },
  {
    name: "District",
    path: paths.addDistrict,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddDistrict />,
  },
  {
    name: "District",
    path: paths.viewDistrict,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewDistrict />,
  },
  {
    name: "District",
    path: paths.editDistrict,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditDistrict />,
  },
  {
    name: "Gender",
    path: paths.addGender,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddGender />,
  },
  {
    name: "Gender",
    path: paths.viewGender,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewGender />,
  },
  {
    name: "Gender",
    path: paths.editGender,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditGender />,
  },
  {
    name: "Legislative Positions",
    path: paths.addLegislativePosition,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddLegislativePosition />,
  },
  {
    name: "Legislative Positions",
    path: paths.editLegislativePosition,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditLegislativePosition />,
  },
  {
    name: "Legislative Positions",
    path: paths.viewLegislativePosition,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewLegislativePosition />,
  },
  {
    name: "Member Names",
    path: paths.viewMemberName,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewMemberName />,
  },
  {
    name: "Member Names",
    path: paths.editMemberName,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditMemberName />,
  },
  {
    name: "Member Names",
    path: paths.addMemberName,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddMemberName />,
  },
  {
    name: "Ministry",
    path: paths.addMinistry,
    exact: true,
    access: ["SuperAdmin"],
    element: <AddMinistry />,
  },
  {
    name: "Ministry",
    path: paths.viewMinistry,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewMinistry />,
  },
  {
    name: "Ministry",
    path: paths.editMinistry,
    exact: true,
    access: ["SuperAdmin"],
    element: <EditMinistry />,
  },
  {
    name: "Navigation",
    path: paths.addNavigation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddNavigation />,
  },
  {
    name: "Navigation",
    path: paths.viewNavigation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewNavigation />,
  },
  {
    name: "Navigation",
    path: paths.editNavigation,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditNavigation />,
  },
  {
    name: "Political Parties",
    path: paths.addPoliticalParty,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddPoliticalParty />,
  },
  {
    name: "Political Parties",
    path: paths.viewPoliticalParty,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewPoliticalParty />,
  },
  {
    name: "Political Parties",
    path: paths.editPoliticalParty,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditPoliticalParty />,
  },
  {
    name: "Legislative Positions",
    path: paths.addPresidingOfficer,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddPresidingOfficer />,
  },
  {
    name: "Legislative Positions",
    path: paths.editPresidingOfficer,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditPresidingOfficer />,
  },
  {
    name: "Legislative Positions",
    path: paths.viewPresidingOfficer,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewPresidingOfficer />,
  },
  {
    name: "SessionField",
    path: paths.addSessionField,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddSessionField />,
  },
  {
    name: "SessionField",
    path: paths.editSessionField,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditSessionField />,
  },
  {
    name: "SessionField",
    path: paths.viewSessionField,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewSessionField />,
  },

  // homes
  {
    name: "AuditTrail",
    path: paths.viewAudit,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewAudit />,
  },
  {
    name: "AuditTrail",
    path: paths.viewUserAudit,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewAllUserAudit />,
  },
  {
    name: "AuditTrail",
    path: paths.viewAllUserAudit,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewUserAudit />,
  },
  {
    name: "ContactUs",
    path: paths.addContact,
    exact: true,
    access: ["SuperAdmin"],
    element: <AddContact />,
  },
  {
    name: "ContactUs",
    path: paths.editContact,
    exact: true,
    access: ["SuperAdmin"],
    element: <EditContact />,
  },
  {
    name: "ContactUs",
    path: paths.viewContact,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewContact />,
  },
  {
    name: "Feedback",
    path: paths.editFeedback,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditFeedback />,
  },
  {
    name: "Feedback",
    path: paths.viewFeedback,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewFeedback />,
  },
  {
    name: "Feedback",
    path: paths.viewAllFeedback,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllFeedback />,
  },
  {
    name: "File Manager",
    path: paths.addFileManager,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <AddFileManager />,
  },
  {
    name: "File Manager",
    path: paths.editFileManager,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <EditFileManager />,
  },
  {
    name: "File Manager",
    path: paths.viewFileManager,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ViewFileManager />,
  },
  {
    name: "Helpdesk",
    path: paths.editHelpdesk,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditHelpdesk />,
  },
  {
    name: "Feedback",
    path: paths.viewAllHelpdesk,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator", "Reviewer"],
    element: <ViewAllHelpdesk />,
  },
  {
    name: "Helpdesk",
    path: paths.viewHelpdesk,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ViewHelpdesk />,
  },
  {
    name: "Portal Branch",
    path: paths.addPortalBranch,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <AddPortalBranch />,
  },
  {
    name: "Portal Branch",
    path: paths.editPortalBranch,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <EditPortalBranch />,
  },
  {
    name: "Portal Branch",
    path: paths.viewPortalBranch,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ViewPortalBranch />,
  },
  {
    name: "Portal Department",
    path: paths.addPortalDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <AddPortalDepartment />,
  },

  {
    name: "Portal Department",
    path: paths.editPortalDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <EditPortalDepartment />,
  },
  {
    name: "Portal Department",
    path: paths.viewPortalDepartment,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ViewPortalDepartment />,
  },
  {
    name: "Portal User",
    path: paths.addPortalUser,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <AddPortalUser />,
  },
  {
    name: "Portal User",
    path: paths.editPortalUser,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <EditPortalUser />,
  },
  {
    name: "Portal User",
    path: paths.viewPortalUser,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ViewPortalUser />,
  },
  {
    name: "Portal User",
    path: paths.blockPortalUser,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <BlockPortalUser />,
  },
  {
    name: "Portal User",
    path: paths.resetPortalUser,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <ResetPortalUser />,
  },
  {
    name: "Portal User",
    path: paths.uploadPortalUser,
    exact: true,
    access: ["SuperAdmin"],
    element: <UploadPortalUser />,
  },
  {
    name: "SEO",
    path: paths.addSeo,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <AddSeo />,
  },
  {
    name: "SEO",
    path: paths.editSeo,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <EditSeo />,
  },
  {
    name: "SEO",
    path: paths.viewSeo,
    exact: true,
    access: ["SuperAdmin", "Admin", "ContentCreator"],
    element: <ViewSeo />,
  },
  {
    name: "Task Management",
    path: paths.addTask,
    exact: true,
    access: ["SuperAdmin"],
    element: <AddTask />,
  },
  {
    name: "Task Management",
    path: paths.editTask,
    exact: true,
    access: ["SuperAdmin"],
    element: <EditTask />,
  },
  {
    name: "Task Management",
    path: paths.viewTask,
    exact: true,
    access: ["SuperAdmin"],
    element: <ViewTask />,
  },
  {
    name: "User Management",
    path: paths.userRole,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <UserRole />,
  },
  {
    name: "User Management",
    path: paths.editRole,
    exact: true,
    access: ["SuperAdmin", "Admin"],
    element: <EditRole />,
  },
  {
    name: "Workflow",
    path: paths.addWorkflow,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <AddWorkflow />,
  },
  {
    name: "Workflow",
    path: paths.editWorkflow,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <EditWorkflow />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflow,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflow />,
  },
  {
    name: "Workflow",
    path: paths.viewAllWorkflow,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewAllWorkflow />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowHistory,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowHistory />,
  },
  {
    name: "Archive",
    path: paths.viewArchive,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewArchive />,
  },

  // pending
  {
    name: "Workflow",
    path: paths.viewWorkflowBiologicalInformation,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowBiologicalInformation />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowContactUs,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowContactUs />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowFaq,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowFaq />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowGallery,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowGallery />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowGalleryImage,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowGalleryImage />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowInterestRequest,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowInterestRequest />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowLegislativeAssembly,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowLegislativeAssembly />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowLegislativeCouncil,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowLegislativeCouncil />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowLibrary,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowLibrary />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowMantriMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowMantriMandal />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowMemberProfile,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowMemberProfile />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowRajyapal,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowRajyapal />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowSessionCalendar,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowSessionCalendar />,
  },
  {
    name: "Workflow",
    path: paths.viewWorkflowVidhanMandal,
    exact: true,
    access: ["SuperAdmin", "Admin", "Reviewer"],
    element: <ViewWorkflowVidhanMandal />,
  },
];
